import { graphql } from '@gql';

export const VildarPaymentSectionFragment = graphql(/* GraphQL */ `
  fragment VildarPaymentSectionFragment on VildarPageComponentsPaymentSection {
    __typename
    payment_section {
      paymentConnection {
        totalCount
        edges {
          node {
            ...VildarPaymentFragment
          }
        }
      }
    }
  }
`);

export const VildarPaymentFragment = graphql(/* GraphQL */ `
  fragment VildarPaymentFragment on VildarPayment {
    __typename
    title
    display_title
    description
    bank_transfer {
      title
      description
    }
    card_payment {
      title
      description
      amount
      button_label
      input_label
    }
    points {
      title
      description
      external_url {
        href
        title
      }
    }
  }
`);
